import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router-dom';

import logo from 'assets/images/logo/logo_white.png';

const HeaderBack = ({ history, location }) => {
  const { pathname } = location;

  let path = '/main';
  if (pathname && pathname.match(/\/(.*?)\/(.*?)\//g)) {
    const [returnPath] = pathname.match(/\/(.*?)\/(.*?)\//g);
    path = returnPath.substring(0, returnPath.length - 1);
  }
  return (
    <div className="header header-back">
      <nav>
        <ul>
          <button onClick={() => history.push(path)}>
            <FontAwesomeIcon icon={['fas', 'chevron-left']} /> Back
          </button>
          <img src={`/${logo}`} className="logo" alt="logo" />
        </ul>
      </nav>
    </div>
  );
};

export default withRouter(HeaderBack);
